<div>
    <h2>{{'mantenimientoExpediciones.title' | translate}}</h2>

    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{ 'show-warning': showWarning, 'show-error':showError }">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.pais' | translate}} *</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.denominacion' | translate}} *</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
                    [disabled]="disabledDenominaciones" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.campanya' | translate}}</label>
                <app-filterable-list [itemsList]="campanyas" [selectedItem]="filtersForm.get('campanya')"
                    [disabled]="disabledCampanya" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.etiquetador' | translate}} *</label>
                <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="filtersForm.get('etiquetador')"
                    [disabled]="disabledEtiquetadores" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.almacen' | translate}} *</label>
                <app-filterable-list [itemsList]="almacenes" [selectedItem]="filtersForm.get('almacen')"
                    [disabled]="disabledAlmacenes" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.finca' | translate}}</label>
                <input type="text" formControlName="finca">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.lote' | translate}}</label>
                <input type="text" formControlName="lote">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.confeccion' | translate}}</label>
                <app-filterable-list [itemsList]="confecciones" [selectedItem]="filtersForm.get('confeccion')"
                    [disabled]="disabledConfecciones" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.type' | translate}}</label>
                <app-filterable-list [itemsList]="tiposConfeccion" [selectedItem]="filtersForm.get('tipoConfeccion')" [placeHolder]="false"></app-filterable-list>
            </div>
            <!-- Div vacío para fechas en última fila en pantallas más grandes, a partir de 1764 -->
            <div *ngIf="showEmptyDiv" class="entry-5"></div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio" (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin" (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'"></div>
            <!-- Divs vacíos para que las columnas se alineen correctamente en pantallas grandes -->
            <div *ngIf="showEmptyDiv" class="entry-5"></div>
            <div *ngIf="showEmptyDiv" class="entry-5"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}" (click)="filtersVisible=!filtersVisible"
          title="{{'global.filtros.abrir' | translate}}">
          <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
          (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
          <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
          [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
          title="{{'global.filtros.limpiar' | translate}}">
          <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
          title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
          <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>

    <section class="export-buttons">
        <i class="fas fa-file-pdf disabled" title="{{'mantenimientoCultivos.exportarA' | translate}} PDF"></i>
        <i class="fa-solid fa-circle-question" title="{{'global.obtenerAyuda' | translate}}" (click)="openDocHelp()"></i>
    </section>

    <div style="display: flex; justify-content: flex-end">
        <!-- Se permite Generar Expedición en la primera pestaña, si hay mínimo 1 checkbox marcado. Deshabilitado para Auditor y Supervisor -->
        <button class="secondary" 
            [ngStyle]="(role === 'Auditor' || role === 'Supervisor') || (activeTab !== 1 || (activeTab === 1 && (!checkedId || checkedId.length < 1))) ? {'border': '1px solid lightgrey', 'color': 'lightgrey', 'cursor': 'default'} : {}"
            [disabled]="(role === 'Auditor' || role === 'Supervisor') || (activeTab !== 1 || (activeTab === 1 && (!checkedId || checkedId.length < 1)))"
            (click)="showNewEditModal(null)">
                <i class="fas fa-truck" style="font-size: .9em;"></i> {{ 'mantenimientoExpediciones.generarExpedicion' | translate }}
        </button>
    </div>
    
    <section class="tabs">
        <ul>
            <li [ngClass]="{'active': activeTab === 1}" (click)="changeActiveTab(1)">{{ 'global.confeccionado' | translate }}</li>
            <li [ngClass]="{'active': activeTab === 2}" (click)="changeActiveTab(2)">{{ 'global.expedicion' | translate }}</li>
        </ul>

        <!-- Solo se devuelven datos de Etiquetadores que tengan el Modo Certificado -->
        <content>
            <!-- Confección -->
            <div class="table-wrapper" *ngIf="activeTab === 1">
                <div class="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th class="icon" style="padding-left: .5rem;">
                                    <input type="checkbox" id="confeccion-main-check"
                                        [checked]="availableConfecciones?.length > 0 && checkedId?.length === availableConfecciones?.length"
                                        [disabled]="mainDisabled" (click)="handleMainCheckClick()">
                                    <label for="confeccion-main-check" style="margin-bottom: unset;"></label>
                                </th>
                                <th class="icon"></th>
                                <th class="date sortable nowrap" (click)="toOrderBy('x=> x.FechaImpresion', 'fechaConfeccion')">
                                    {{ 'global.fecha.confeccion' | translate }}
                                    <div class="sortable-icons">
                                        <i [ngClass]="getIcon('fechaConfeccion')"></i>
                                    </div>
                                </th>
                                <th class="string sortable nowrap" (click)="toOrderBy('x=> x.Lote', 'lote')">
                                    {{ 'global.lote' | translate }}
                                    <div class="sortable-icons">
                                        <i [ngClass]="getIcon('lote')"></i>
                                    </div>
                                </th>
                                <th class="string">
                                    {{ 'global.denominacion' | translate }}
                                </th>
                                <th class="string">
                                    {{ 'global.finca' | translate }}
                                </th>
                                <th class="string sortable nowrap" (click)="toOrderBy('x=> x.ConsumosDetalle.Select(y => y.Designacion.Cultivo.Finca.Municipio).OrderBy(y => y.Des).FirstOrDefault().Des', 'municipio')">
                                    {{ 'global.municipio' | translate }}
                                    <div class="sortable-icons">
                                        <i [ngClass]="getIcon('municipio')"></i>
                                    </div>
                                </th>
                                <th class="string sortable nowrap" (click)="toOrderBy('x=> x.ConsumosDetalle.SelectMany(y => y.Designacion.Cultivo.CultivosProductor.Select(z => z.Productor)).OrderBy(y => y.Des).FirstOrDefault().Des', 'productores')">
                                    {{ 'global.productorProductores' | translate }}
                                    <div class="sortable-icons">
                                        <i [ngClass]="getIcon('productores')"></i>
                                    </div>
                                </th>
                                <th class="string sortable nowrap" (click)="toOrderBy('x=> x.Confeccion.Des', 'confeccion')">
                                    {{ 'global.confeccion' | translate }}
                                    <div class="sortable-icons">
                                        <i [ngClass]="getIcon('confeccion')"></i>
                                    </div>
                                </th>
                                <th class="string">
                                    {{ 'global.type' | translate }}
                                </th>
                                <th class="number">
                                    {{ 'mantenimientoExpediciones.available' | translate }}
                                </th>
                                <th class="number">
                                    {{ 'global.expedicion' | translate }}
                                </th>
                                <th class="progress">
                                    {{ 'global.porcentajeExpedicion' | translate }}
                                </th>
                                <th class="actions"></th>
                            </tr>
                        </thead>

                        <tbody *ngFor="let confeccion of confeccionesExpediciones; let i = index; trackBy: trackByConfeccionId">
                            <tr (click)="toggleDropdownInfo(i);" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
                                <td class="icon" style="padding-left: .5rem;">
                                    <!-- Deshabilitado si no hay cajas/pallets disponibles (también tenemos en cuenta si ha habido excesos). También si está Bloqueado -->
                                    <input type="checkbox" id="confeccion-check-{{confeccion.id}}"
                                        [checked]="checkedId?.includes(confeccion.id)"
                                        [disabled]="(role === 'Auditor' || role === 'Supervisor') || (!confeccion.unidadesDisponibles || confeccion.unidadesDisponibles < 0)"
                                        (change)="handleSecondaryChecksValue($event.target.checked, confeccion.id)">
                                    <label for="confeccion-check-{{confeccion.id}}" style="margin-bottom: unset;"></label>
                                </td>
                                <td class="icon">
                                    <i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                                        title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                                </td>
                                <td class="date">{{ confeccion.fechaConfeccion | date: 'shortDate' : undefined : defaultLanguage }}</td>
                                <td class="string">{{ confeccion.lote }}</td>
                                <td class="string">{{ confeccion.desDenominacion }}</td>
                                <td class="string">{{ confeccion.desFinca }}</td>
                                <td class="string">{{ confeccion.desMunicipio }}</td>
                                <td class="string">{{ confeccion.desProductor }}</td>
                                <td class="string">{{ confeccion.desConfeccion }}</td>
                                <!-- 1: Caja, 2: Pallet -->
                                <td class="string">{{ confeccion.tipoConfeccionId === 1 ? ('global.caja' | translate) : 
                                    confeccion.tipoConfeccionId === 2 ? ('global.pallet' | translate) : '' }}</td>
                                <td class="number">{{ confeccion.unidadesDisponibles | number : '1.0-0': defaultLanguage }}</td>
                                <td class="number">{{ confeccion.unidadesExpedicion | number : '1.0-0': defaultLanguage }}</td>
                                <td class="progress" style="padding: 0 .5rem;">
                                    <progress
                                        [ngClass]="{ 'exceeded': confeccion.porcentajeExpedicion > 100 }"
                                        value="{{confeccion.porcentajeExpedicion}}"
                                        max="100"></progress>
                                        <span>{{ (confeccion.porcentajeExpedicion | number : '1.0-2' : defaultLanguage) || 0 }}%</span>
                                </td>
                                <td class="actions">
                                    <i  class="fas fa-stream" 
                                        title="{{ dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate) }}"
                                        app-click-stop-propagation (click)="toggleDropdownSection(i)"></i>
                                </td>
                            </tr>

                            <!-- Panel "Más Información" -->
                            <tr *ngIf="dropdownInfo === i">
                                <td colspan="15">
                                    <div class="detail">
                                        <div class="title">{{'global.masInformacion' | translate}}</div>
                                        <div class="block-inline">
                                            <label>{{'global.confeccionUnidades' | translate}}</label>
                                            <p>{{ confeccion.unidadesTotales | number : '1.0-0': defaultLanguage }}</p>
                                        </div>
                                        <div class="block-inline">
                                            <label>{{'global.returnedUnits' | translate}}</label>
                                            <p>{{ confeccion.unidadesDevueltas | number : '1.0-0': defaultLanguage }}</p>
                                        </div>
                                        <div class="block-inline">
                                            <label>SNC</label>
                                            <p>{{ confeccion.seriadoFijo }}</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>

                            <!-- Subtabla Expediciones -->
                            <tr *ngIf="dropdownSection === i">
                                <td colspan="15">
                                    <section class="tabs">
                                        <ul>
                                            <li class="active">{{ 'mantenimientoExpediciones.title' | translate }}</li>
                                        </ul>
                                        <content>
                                            <app-expediciones [confeccionId]="confeccion.id"></app-expediciones>
                                        </content>
                                    </section>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot *ngIf="!confeccionesExpediciones || (confeccionesExpediciones && confeccionesExpediciones.length < 1)">
                            <tr>
                                <td colspan="15">
                                    {{ 'global.noContent' | translate }}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

            <!-- Expedición -->
            <div class="table-wrapper" *ngIf="activeTab === 2">
                <div class="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th class="icon"></th>
                                <th class="icon"></th>
                                <th class="icon"></th>
                                <th class="id">ID</th>
                                <th class="date sortable nowrap" (click)="toOrderBy('x=> x.FechaIns', 'fechaExpedicion')">
                                    {{ 'global.fecha.expedicion' | translate }}
                                    <div class="sortable-icons">
                                        <i [ngClass]="getIcon('fechaExpedicion')"></i>
                                    </div>
                                </th>
                                <th class="string sortable nowrap" (click)="toOrderBy('x=> x.ConsumosCertificadoExpedicion.Select(y => y.Consumo.Lote).OrderBy(y => y).FirstOrDefault()', 'lote')">
                                    {{ 'global.loteLotes' | translate }}
                                    <div class="sortable-icons">
                                        <i [ngClass]="getIcon('lote')"></i>
                                    </div>
                                </th>
                                <th class="string">
                                    {{ 'global.denominacion' | translate }}
                                </th>
                                <th class="string">
                                    {{ 'global.finca' | translate }}
                                </th>
                                <th class="number sortable nowrap" (click)="toOrderBy('x=> x.ConsumosCertificadoExpedicion.Sum(y => y.Unidades)', 'cajas')">
                                    {{ 'global.cajas' | translate }}
                                    <div class="sortable-icons">
                                        <i [ngClass]="getIcon('cajas')"></i>
                                    </div>
                                </th>
                                <th class="string">{{ 'global.matricula' | translate }}</th>
                                <th class="string sortable nowrap" (click)="toOrderBy('x=> x.NCertificadoExpedicion', 'numCertificado')">
                                    {{ 'global.certificadoNum' | translate }}
                                    <div class="sortable-icons">
                                        <i [ngClass]="getIcon('numCertificado')"></i>
                                    </div>
                                </th>
                                <th class="icon sortable nowrap" (click)="toOrderBy('x=> x.EstadoId', 'estado')">
                                    {{ 'global.estado' | translate }}
                                    <div class="sortable-icons">
                                        <i [ngClass]="getIcon('estado')"></i>
                                    </div>
                                </th>
                                <th class="date sortable nowrap" (click)="toOrderBy('x=> x.FechaInicioVigencia', 'fechaInicioVigencia')">
                                    {{ 'global.fecha.inicioVigencia' | translate }}
                                    <div class="sortable-icons">
                                        <i [ngClass]="getIcon('fechaInicioVigencia')"></i>
                                    </div>
                                </th>
                                <th class="date sortable nowrap" (click)="toOrderBy('x=> x.FechaFinVigencia', 'fechaFinVigencia')">
                                    {{ 'global.fecha.finVigencia' | translate }}
                                    <div class="sortable-icons">
                                        <i [ngClass]="getIcon('fechaFinVigencia')"></i>
                                    </div>
                                </th>
                                <th class="actions"></th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let expedicion of confeccionesExpediciones; let i = index; trackBy: trackByExpedicionId">
                            <tr (click)="toggleDropdownInfo(i);" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
                                <td class="icon">
                                    <i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'" title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                                </td>
                                <td class="icon">
                                    <a *ngIf="expedicion && expedicion.certificadoExpedicionVechain?.existeRegBlockchain" target="_blank">
                                        <i class="fas fa-circle-nodes" title="{{'global.blockchain.verBlockchain' | translate}}" style="cursor: pointer;"></i>
                                    </a>
                                </td>
                                <td class="icon">
                                    <a *ngIf="expedicion && expedicion.certificadoExpedicionBloqAuto" target="_blank">
                                        <i class="fa-solid fa-exclamation" [style]="'color: #e61717'" title="{{'global.verError' | translate}}" style="cursor: pointer;" (click)="showAlertModal()" app-click-stop-propagation></i>
                                    </a>
                                </td>
                                <td class="id">{{ expedicion.id }}</td>
                                <td class="date">{{ expedicion.fechaExpedicion | date: 'shortDate' : undefined : defaultLanguage }}</td>
                                <td class="string">{{ expedicion.lote }}</td>
                                <td class="string">{{ expedicion.desDenominacion }}</td>
                                <td class="string">{{ expedicion.desFinca }}</td>
                                <td class="number">{{ expedicion.sumNumCajas | number : '1.0-0': defaultLanguage }}</td>
                                <td class="string">{{ expedicion.matricula }}</td>
                                <td class="string">{{ expedicion.nCertificadoExpedicion }}</td>
                                <!-- Pendiente: 1, Concedido/Válido: 2, Retirado/Inválido: 3, Cancelado: 4, Expirado: 5 -->
                                <td class="icon">
                                    <i class="far fa-check-circle" [ngStyle]="getCheckIconColor(expedicion.estadoId)" [title]="getCheckIconTitle(expedicion.estadoId)"></i>
                                </td>
                                <td class="date">{{ expedicion.fechaInicioVigencia | date: 'shortDate' : undefined : defaultLanguage }}</td>
                                <td class="date">{{ expedicion.fechaFinVigencia | date: 'shortDate' : undefined : defaultLanguage }}</td>
                                <td class="multi-actions-bigger">
                                    <i  class="fas fa-stream" 
                                        title="{{ dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate) }}"
                                        app-click-stop-propagation (click)="toggleDropdownSection(i)"></i>
                                    <!-- Edición, firma y borrado deshabilitados si ya NO está pendiente !!
                                        Doc deshabilitado si aún está pendiente de firma -->
                                    <i  class="fas fa-pencil-alt" [ngClass]="{ 'disabled': (role === 'Auditor' || role === 'Supervisor') || expedicion.estadoId !== 1 }"
                                        title="{{'titles.editar' | translate}}"
                                        app-click-stop-propagation (click)="showNewEditModal(expedicion.id)"></i>
                                    <i  class="fas fa-pen-nib" [ngClass]="{ 'disabled': role === 'Auditor' || role === 'Supervisor' || expedicion.estadoId !== 1 || expedicion.certificadoExpedicionBloqAuto }" 
                                        [title]="'titles.firmarCertificado' | translate"
                                        app-click-stop-propagation (click)="showPdfModal(expedicion.id, 'sign')"></i>
                                    <i  class="fas fa-file" [ngClass]="{ 'disabled': expedicion.estadoId === 1 }" 
                                        [title]="'titles.verCertificado' | translate"
                                        app-click-stop-propagation (click)="showPdfModal(expedicion.id, 'view')"></i>
                                    <i  class="far fa-trash-alt" [ngClass]="{ 'disabled': (role === 'Auditor' || role === 'Supervisor') || expedicion.estadoId !== 1 }" 
                                        title="{{'titles.eliminar' | translate}}"
                                        app-click-stop-propagation (click)="showDeleteModal(expedicion.id)"></i>
                                </td>
                            </tr>

                            <!-- Panel "Más Información" -->
                            <tr *ngIf="dropdownInfo === i">
                                <td colspan="15">
                                    <div class="detail">
                                        <div class="title">{{'global.masInformacion' | translate}}</div>

                                        <div class="block-inline gap nowrap">
                                            <label>{{'global.csvLong' | translate}}</label>
                                            <p>{{ expedicion.codigoSeguroVerificacion }}</p>
                                        </div>
                                        <div class="block-inline"><label></label><p></p></div>
                                        <div class="block-inline">
                                            <label>{{ 'global.fecha.firma' | translate }}</label>
                                            <p>{{ expedicion.fechaInicioVigencia | date: 'shortDate' : undefined : defaultLanguage }}</p>
                                        </div>
                                        <div class="block-inline"><label></label><p></p></div>
                                        <div class="block-inline">
                                            <label>{{ 'global.fecha.insercionShort' | translate }}</label>
                                            <p>{{ expedicion.fechaIns | date: 'shortDate' : undefined : defaultLanguage }}</p>
                                        </div>
                                        <div class="block-inline"><label></label><p></p></div>
                                        <div class="block-inline">
                                            <label>{{ 'global.fecha.actualizacionShort' | translate }}</label>
                                            <p>{{ expedicion.fechaUpd | date: 'shortDate' : undefined : defaultLanguage }}</p>
                                        </div>
                                        <div class="block-inline"><label></label><p></p></div>
                                    </div>
                                </td>
                            </tr>
                            
                            <!-- Panel "Blockchain Información" -->
                            <tr *ngIf="dropdownInfo === i && (expedicion && expedicion.certificadoExpedicionVechain?.existeRegBlockchain)">
                                <td colspan="15">
                                    <div class="detail">
                                        <div class="title">{{'global.blockchain.informacion.titulo' | translate}}</div>
                                        <div class="block-inline">
                                            <label>{{'global.blockchain.informacion.blockchain' | translate}}</label>
                                            <span>
                                                {{expedicion.certificadoExpedicionVechain?.blockchain}}
                                                <a 
                                                    style="color: #A39B4B; text-decoration: none; font-family: 'regular';" 
                                                    [href]="getBlockchainLink(expedicion.certificadoExpedicionVechain?.txId)" target="_blank">
                                                        ({{'global.blockchain.informacion.enlace' | translate}})</a>
                                            </span>
                                        </div>
                                        <div class="block-inline"><label></label><p></p></div>
                                        <div class="block-inline">
                                            <label>{{'global.blockchain.informacion.fechaRegistro' | translate}}</label>
                                            <p>{{expedicion.certificadoExpedicionVechain?.fechaRegistro | date: 'dd/MM/yyyy HH:mm:ss'}}</p>
                                        </div>
                                        <div class="block-inline"><label></label><p></p></div>
                                        <div class="block-inline gap nowrap">
                                            <label>{{'global.blockchain.informacion.input' | translate}}</label>
                                            <p>{{expedicion.certificadoExpedicionVechain?.textoHash}}</p>
                                        </div>
                                        <div class="block-inline"><label></label><p></p></div>
                                        <div class="block-inline"><label></label><p></p></div>
                                        <div class="block-inline"><label></label><p></p></div>
                                        <div class="block-inline gap nowrap">
                                            <label>{{'global.blockchain.informacion.idCripto' | translate}}</label>
                                            <p>{{expedicion.certificadoExpedicionVechain?.txId}}</p>
                                        </div>
                                        <div class="block-inline"><label></label><p></p></div>
                                        <div class="block-inline"><label></label><p></p></div>
                                        <div class="block-inline"><label></label><p></p></div>
                                        <div class="block-inline gap nowrap">
                                            <label>{{'global.blockchain.informacion.hash' | translate}}</label>
                                            <p>{{expedicion.certificadoExpedicionVechain?.hash}}</p>
                                        </div>
                                        <div class="block-inline"><label></label><p></p></div>
                                        <div class="block-inline"><label></label><p></p></div>
                                        <div class="block-inline"><label></label><p></p></div>
                                    </div>
                                </td>
                            </tr>

                            <!-- Subtabla Confecciones -->
                            <tr *ngIf="dropdownSection === i">
                                <td colspan="15">
                                    <section class="tabs">
                                        <ul>
                                            <li class="active">{{ 'mantenimientoConfecciones.titulo' | translate }}</li>
                                        </ul>
                                        <content>
                                            <app-confecciones [expedicionId]="expedicion.id"></app-confecciones>
                                        </content>
                                    </section>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot *ngIf="!confeccionesExpediciones || (confeccionesExpediciones && confeccionesExpediciones.length < 1)">
                            <tr>
                                <td colspan="15">
                                    {{ 'global.noContent' | translate }}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

            <app-paginator 
                *ngIf="confeccionesExpediciones && confeccionesExpediciones.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
                [totalItems]="totalItems" [visiblePages]="visiblePages" 
                (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>

            <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=showWarning=$event"></app-toast>
        </content>
    </section>
</div>

<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{ expedicionId ? ('mantenimientoExpediciones.titleEdit' | translate) : ('mantenimientoExpediciones.generarExpedicion' | translate) }}</h4>
        </header>
        <app-new-edit-expedicion [expedicionId]="expedicionId" [denominacionId]="denominacionId" [generarExpedicionItems]="generarExpedicionItems" (refresh)="refresh($event)" (mensaje)="pushMessage($event)"></app-new-edit-expedicion>
    </div>
</div>

<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
        </header>
        <content>
            <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
        </content>
        <footer>
            <button class="secondary" (click)="closeDeleteModal()">{{ 'global.cancelar' | translate }}</button>
            <button (click)="deleteExpedicion()">{{ 'global.confirmar' | translate }}</button>
        </footer>
    </div>
</div>

<div class="modal" *ngIf="alertModal">
    <div class="modal-content" style="max-width: 40rem;">
        <header>

        </header>
        <content>
            <p>{{ activeTab === 1 ? ('global.error.expedicionBloqueadaParte1' | translate) : ('global.error.certificadoBloqueadoParte1' | translate) }}</p>
            <p>{{ 'global.error.certificadoBloqueadoParte2' | translate }}</p>
        </content>
        <footer style="justify-content: flex-end;">
            <button (click)="closeAlertModal()">{{ 'global.cerrar' | translate }}</button>
        </footer>
    </div>
</div>

<div class="modal" *ngIf="pdfModal">
    <!-- Evitar doble scroll con overflow-y: hidden -->
    <div class="modal-content" style="width: 99vw; height: 95vh; overflow-y: hidden;">
        <header>
            <h4>{{ pdfMode === 'sign' ? ('titles.firmarCertificado' | translate) : ('titles.verCertificado' | translate) }}</h4>
        </header>
        <content style="height: 100%;">
            <!-- Usar clase "user-select" solo en casos como este (PDF del Certificado), cuando se permita la selección y copia de texto !! -->
            <viewer-pdf class="user-select" [base64PdfModal]="base64Certificado"></viewer-pdf>
        </content>
        <footer style="justify-content: flex-end; gap: 3em;">
            <button class="secondary" (click)="closeSignaturePdfModal()">
                {{ pdfMode === 'sign' ? ('global.cancelar' | translate) : ('global.cerrar' | translate) }}</button>
            <button (click)="signOrDownlowadCertificado()">
                {{ pdfMode === 'sign' ? ('global.firmar' | translate) : ('global.descargar' | translate) }}</button>
        </footer>
    </div>
</div>